import { useMutation } from "@apollo/client/react";
import { SaveExportDocument, SaveSourceBundleDocument } from "../../graphql/types";
import { StatefulButton } from "../ui/muiButtons";

import { WrenchIcon } from "@phosphor-icons/react/dist/csr/Wrench";
import { toast } from "react-toastify";

type UnsuspendTransferButtonProps = {
  type: "download" | "upload";
  name: string;
  refreshData: () => Promise<void>;
  refreshing: boolean;
  inline?: boolean;
};

const UnsuspendTransferButton = ({ type, name, refreshData, inline, refreshing }: UnsuspendTransferButtonProps) => {
  const [unsuspendDownload, unsuspendDownloadState] = useMutation(SaveSourceBundleDocument, {
    variables: {
      name,
      status: "active",
    },
    fetchPolicy: "no-cache",
    onCompleted: async () => {
      toast.success(`${name} unsuspended successfully!`);
      await refreshData();
    },
    onError: (error) => {
      toast.error("There was an error unsuspending the download.");
      console.error("There was an error unsuspending the download", error);
    },
  });
  const [unsuspendUpload, unsuspendUploadState] = useMutation(SaveExportDocument, {
    variables: {
      name,
      status: "active",
    },
    fetchPolicy: "no-cache",
    onCompleted: async () => {
      toast.success(`${name} unsuspended successfully!`);
      await refreshData();
    },
    onError: (error) => {
      toast.error("There was an error unsuspending the upload.");
      console.error("There was an error unsuspending the upload", error);
    },
  });

  const handleClick = () => {
    if (type === "download") {
      unsuspendDownload();
    } else {
      unsuspendUpload();
    }
  };

  return (
    <StatefulButton
      loading={unsuspendDownloadState.loading || unsuspendUploadState.loading || refreshing}
      variant={inline ? "contained" : "outlined"}
      color="primary"
      onClick={handleClick}
      size={inline ? "xSmall" : undefined}
      sx={{
        wordBreak: "normal",
      }}
    >
      Unsuspend
      {inline ? <WrenchIcon size={16} /> : null}
    </StatefulButton>
  );
};

export { UnsuspendTransferButton };
